import { useEffect, useRef, useState, useCallback } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import videoInicio from '../img/videoInicio.mp4';
import presentacionInicial1 from '../img/Carrusel/presentacionInicial1.png';
import presentacionInicial2 from '../img/Carrusel/presentacionInicial2.png';
import presentacionInicial3 from '../img/Carrusel/presentacionInicial3.png';
import presentacionInicial4 from '../img/Carrusel/presentacionInicial4.png';
import { Helmet } from 'react-helmet';
import Footer from '../Layouts/Footer';
import '../App.css';

function Homepage() {
  const [showContent, setShowContent] = useState(() => {
    return sessionStorage.getItem('videoShown') === 'true';
  });

  const videoRef = useRef(null);

  const handleVideoEnd = useCallback(() => {
    sessionStorage.setItem('videoShown', 'true');
    setShowContent(true);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (!showContent && video) {
      video.play().catch(err => console.error('Error al reproducir video:', err));
      video.addEventListener('ended', handleVideoEnd);
    }
    return () => {
      if (video) {
        video.removeEventListener('ended', handleVideoEnd);
      }
    };
  }, [showContent, handleVideoEnd]);

  return (
    <div className="homepage-container">
      <Helmet>
        <title>Fire Defense Innovation | Sistemas Contra Incendios en Colombia</title>
        <meta
          name="description"
          content="Expertos en protección contra incendios. Soluciones en bombas, equipos de presión, sistemas especializados y más."
        />
        <link rel="canonical" href="https://fdi.com.co/" />
      </Helmet>

      {!showContent ? (
        <div className="video-center-wrapper">
          <video
            ref={videoRef}
            className="video-reduced"
            muted
            autoPlay
            playsInline
          >
            <source src={videoInicio} type="video/mp4" />
            Tu navegador no soporta el video.
          </video>
        </div>
      ) : (
        <>
          <div className="carousel-wrapper">
            <div className="carousel-background">
              <Carousel>
                <Carousel.Item>
                  <img
                    className="carousel-img"
                    src={presentacionInicial1}
                    alt="Primer slide"
                    loading="lazy"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="carousel-img"
                    src={presentacionInicial2}
                    alt="Segundo slide"
                    loading="lazy"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="carousel-img"
                    src={presentacionInicial3}
                    alt="Tercer slide"
                    loading="lazy"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="carousel-img"
                    src={presentacionInicial4}
                    alt="Cuarto slide"
                    loading="lazy"
                  />
                </Carousel.Item>
              </Carousel>
            </div>
          </div>
          <Footer />
        </>
      )}
    </div>
  );
}

export default Homepage;
